<template>
    <div>

        <transition name="slide-fade">
            <app-top-bar v-if="topbar"
                         :services="services"
                         @setParentService="service = $event"
                         @openOrderModal="orderModal = true">
                ></app-top-bar>
        </transition>

        <section id="f-lv1-search" class="section" :style="'background-image:url(\''+banner+'\');'">

            <div class="icontitle">
                <div>
                    <img :src="$route.meta.icon" alt="">
                </div>
                <h2 v-html="$route.meta.title">
                </h2>

            </div>

            <div class="container">
                <div class="columns">
                    <div class="column"></div>
                    <div class="column is-four-fifths-tablet">
                        <search-drop-down
                                :services="services"
                                @setParentService="service = $event"
                                @openOrderModal="orderModal = true">

                        </search-drop-down>
                    </div>
                    <div class="column"></div>
                </div>

            </div>

            <div class="popserv">
                <p v-if="servpop && servpop.length > 0">Serviços populares: <span @click="service = servpop[0]; orderModal = true;">{{servpop[0].title}}</span>, <span @click="service = servpop[1]; orderModal = true;">{{servpop[1].title}}</span>, <span @click="service = servpop[2]; orderModal = true;">{{servpop[2].title}}</span></p>
            </div>

        </section>

        <section id="f-lv1-list" class="section">

            <h2>{{$route.meta.categoryName}}</h2>

            <div class="container" style="column-count: 2; column-gap:4rem;">

                <div class="subgroup" v-for="s in sg">
                    <p class="sgtitle"><b>{{s.title}}</b></p>
                    <p class="service" v-for="sv in services" v-if="sv.sub_group_id === s.id" @click="service = sv; orderModal = true;">{{sv.title}}</p>
                </div>





            </div>

        </section>




        <app-why-use></app-why-use>

        <app-modal-order  :service="service" :orderModal="orderModal" v-on:closeOrderModal="orderModal = false"></app-modal-order>

        <app-newsletter :wor="true"></app-newsletter>

    </div>
</template>

<script>
import AppTopBar from "../components/TopBar";

import AppNewsletter from "../components/Newsletter.vue";
import SearchDropDown from "../components/SearchDropDown";
import AppModalOrder from "../components/ModalOrder";
import AppWhyUse from "../components/WhyUse.vue";
//import {subgroups} from "../plugins/subgroups";
import { apiUrl } from "../vars";
import helpers from "../plugins/helpers";
import {scrollTop} from "../plugins/scrollTopMixin";

export default {
  components: {
    AppTopBar,
    SearchDropDown,
    AppModalOrder,
    AppNewsletter,
    AppWhyUse
  },
	mixins: [scrollTop],

  data() {
    return {
      helpers,

      subgroups: [],

      services: [],
      banner: this.$route.meta.banner,

      //TODO: update with API
      servpop: [],

      sg: [],

      service: null,
      orderModal: false,

      topbar: false
    };
  },

  watch: {
    "$route.name": function() {
      //this.services = this.$route.meta.services;
      this.banner = this.$route.meta.banner;
      this.initialize();
    }
  },

  methods: {
    handleScroll(event) {
      let bar = document.getElementById("servicesbar");

      this.topbar = !helpers.isScrolledIntoView(bar);
    },
    getSubGroups() {
      axios.get(apiUrl + "/api/site/subgroups").then(r  => {
        this.subgroups = r.data;
        for (let i = 0; i < this.subgroups.length; i++) {
          if (this.subgroups[i]["main_group_id"] === this.$route.meta.main) {
            this.sg.push(this.subgroups[i]);
          }
        }
      });
    },
    getPopServices() {
      axios
        .get(
          apiUrl + "/api/service/maingroup/" + this.$route.meta.main + "/pop"
        )
        .then(r => {
          this.servpop = r.data;
        })
        .catch(e => {
          console.error(e);
        });
    },
    getServices() {
      axios
        .get(apiUrl + "/api/service/maingroup/" + this.$route.meta.main)
        .then(r => {
          this.services = r.data;
        })
        .catch(e => {
          console.error(e);
        });
    },
    initialize() {
      //this.sg = helpers.sort(this.sg, 'title');

      this.getServices();
      this.getSubGroups();
      this.getPopServices();
    }
  },

  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },

  created() {
    this.messageModal = this.$route.params.message;
    window.addEventListener("scroll", this.handleScroll);

    this.initialize();
  }
};
</script>
<style scoped>
.sgtitle {
  margin: 0 0 1rem;
}

.subgroup {
  margin-bottom: 2rem;
  break-inside: avoid-column;
  -webkit-column-break-inside: avoid;
  page-break-inside: avoid;
  display: block;
}

.service {
  cursor: pointer;
}

.icontitle {
  padding: 14rem 0 2rem;
  text-align: center;
  color: white;
}

.icontitle h2 {
  text-align: center;
  color: white;
  font-size: 2.3rem;
  font-weight: 700;
}

.icontitle img {
  text-align: center;
  color: white;
  margin: auto;
}

.popserv {
  padding: 0.5rem 0 2rem;
  text-align: center;
  color: white;
}

.popserv p {
  text-align: center;
  color: white;
  font-size: 0.8rem;
  font-weight: 300;
}

.popserv p span {
  cursor: pointer;
}

.popserv p span:hover {
  cursor: pointer;
  text-decoration: underline;
}

.line {
  border-bottom: solid 1px #969696;
  max-height: 2.5rem;
}

h1 {
  font-weight: 500;
  font-size: 2.3rem;
  line-height: 1.15;
  color: #2d3256;
  margin: 3rem 0 0.5rem;
  padding: 0 2rem;
  text-align: center;
}

h2 {
  color: #e90054;
  font-weight: 700;
  font-size: 2.2rem;
  text-align: center;
}

.iphone {
  position: relative;
  background-image: url("/static/images/level1/iphonemockup.png");
  background-size: 100%, contain;
  background-position: top;
  height: 100%;
}

.f-intro-subtitle {
  color: black;
  font-weight: 700;
  font-size: 1.2rem;
  padding: 1rem 0;
}

.f-intro-text {
  color: #7a7a7a;
  font-weight: 400;
  font-size: 1rem;
  padding-bottom: 1rem;
  line-height: 1.35;
  text-align: justify;
}

#f-lv1-search {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  min-height: 28rem;
  margin-top: -14rem;
}

#f-lv1-list {
  background-color: white;
  padding: 3rem 0 3rem;
  color: black;
}

#f-lv1-list h2 {
  color: #e90054;
  font-weight: 700;
  font-size: 2.3rem;
  margin-bottom: 2rem;
}

#f-lv1-why {
  background-color: #ffffff;
}

.button {
  margin-top: 2rem;
  border-width: 3px;
  font-size: 1rem;
  padding: 1.2rem 1rem;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/pages/Level1.vue